/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const spacerMarginCss = css({
  marginTop: 24,
  marginBottom: 64,
  [MediaQueries.md]: {
    marginTop: 56,
    marginBottom: 96,
  },
  [MediaQueries.lg]: {
    marginTop: 56,
    marginBottom: 96,
  },
  [MediaQueries.xl]: {
    marginTop: 55,
    marginBottom: 96,
  },
});

export const spacerPaddingCss = css({
  paddingTop: 24,
  paddingBottom: 64,
  [MediaQueries.md]: {
    paddingTop: 56,
    paddingBottom: 96,
  },
  [MediaQueries.lg]: {
    paddingTop: 56,
    paddingBottom: 96,
  },
  [MediaQueries.xl]: {
    paddingTop: 55,
    paddingBottom: 96,
  },
});

export const ResultsCardsGridHeaderCss = css({
  marginBottom: 24,
  flexDirection: 'column',
  [MediaQueries.mdAndUp]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  [MediaQueries.xl]: {
    marginBottom: 27,
  },
});

export const cardColumnCss = css({
  marginBottom: 24,
  [MediaQueries.lgAndUp]: {
    marginBottom: 40,
  },
});

export const locationsCss = css(typography.effra18, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
});

export const locationsDisclaimerCss = css(typography.effra16, {
  color: colorsPalette.grey60,
  display: 'inline-block',
  marginRight: 8,
});

export const locationDisclaimerIconCss = css({
  display: 'none',
  borderRadius: '50%',
  background: colorsPalette.brown20,
  verticalAlign: 'middle',
  cursor: 'pointer',
  [MediaQueries.mdAndUp]: {
    display: 'inline',
  },
});

export const tooltipCss = css(typography.effra16, {
  '> div': {
    minWidth: 335,
    boxShadow: shadows.shadow40,
    zIndex: 2,
    '> div': {
      padding: '16px 24px',
      color: colorsPalette.grey80,
    },
  },
});

export const arrowContainerCss = css({
  border: 0,
  backgroundColor: colorsPalette.transparent,
  cursor: 'pointer',
  position: 'absolute',
  right: 20,
  width: 48,
  height: 48,
  bottom: -145,
  zIndex: 1,
  display: 'none',
  [MediaQueries.mdAndUp]: {
    display: 'block',
  },
});

export const backToTopArrowCss = css({
  transform: 'rotate(90deg)',
  cursor: 'pointer',
});

export const noResultsCss = css({
  marginBottom: 24,
});
